<h2 mat-dialog-title style="text-align: center">
  Möchten Sie wirklich das Team <span style="font-weight:600">{{teamName}}</span> löschen ?
</h2>
<mat-dialog-content class="mat-typography">
  <div style="height: 0.5rem"></div>
</mat-dialog-content>
<div
  mat-dialog-actions
  class="row-layout"
  style="justify-content: space-between"
>
  <button mat-button (click)="doNotDelete()">Nein</button>
  <button mat-button style="margin-left: 1rem" (click)="doDelete()">Ja</button>
</div>
